module.exports = __webpack_public_path__ + "img/ueber-mich_3000.3155c7b1.webp";